import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { MatExpansionModule } from '@angular/material';
import { GoalDetailsModule } from '../../goal/details/goal-details/goal-details.module';
import { CareplanDetailsChangesComponent } from './careplan-details-changes.component';
import { DetailsChangesModule } from './changes/details-changes.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule, MatExpansionModule, GoalDetailsModule, DetailsChangesModule],
  declarations: [CareplanDetailsChangesComponent],
  exports: [CareplanDetailsChangesComponent]
})
export class CareplanDetailsChangesModule { }
